// libs
import React, { memo, useState, useEffect } from "react";

// global components
import WithStyles from "shared/components/WithStyles";
import Modal, { ModalContext } from "shared/components/Modal";

// helpers
import { getAkamaiUrl } from "shared/helpers/utils";

// api
import { setGDPROption } from "shared/api/gdpr";

// constants
import { LINKS } from "shared/components/GDPR/constants";
import { TEXT, BG_IMG, IMG_WIDTH, SHOW_NEWS_LETTER, NEWS_SUBSCRIPTION } from "./constants";

// styles
import { modalCss, GDPRModalContentCss } from "./styles";

// defs
import { IGDPRModalProps } from "./types";

function NewsletterSubscriber({ email, hasOptedForNewsletter, onGDPRNetwork }: IGDPRModalProps) {
    const [shouldShowNewsletter, setShouldShowNewsletter] = useState(false);

    useEffect(() => {
        if (onGDPRNetwork) {
            if (String(hasOptedForNewsletter) === SHOW_NEWS_LETTER) {
                setShouldShowNewsletter(true);
            }
        }
    }, [hasOptedForNewsletter, onGDPRNetwork]);

    const onHide = () => {
        setShouldShowNewsletter(false);
    };

    if (shouldShowNewsletter === false) {
        return null;
    }

    return (
        <Modal css={modalCss} onHide={onHide} className="modal" allowBackdropClick={false}>
            <ModalContext.Consumer>
                {({ hide }) => {
                    const setGdprApiCall = () => {
                        setGDPROption(email, NEWS_SUBSCRIPTION.YES);
                        hide();
                    };

                    const unsetGdprApiCall = () => {
                        setGDPROption(email, NEWS_SUBSCRIPTION.NO);
                        hide();
                    };

                    return (
                        <WithStyles cssProps={GDPRModalContentCss} data-test="nws-modal">
                            <img
                                className="main-image"
                                src={getAkamaiUrl(BG_IMG, { width: 2 * IMG_WIDTH })}
                                width={IMG_WIDTH}
                                alt="banner for news letter subscription"
                                // @ts-ignore
                                loading="lazy"
                            />

                            <div className="GDPRContent">
                                <p className="title">{TEXT.INFO}</p>

                                <button
                                    className="btn btn-primary"
                                    data-test="nws-btn-yes"
                                    onClick={setGdprApiCall}
                                >
                                    {TEXT.OPT_IN}
                                </button>

                                <button
                                    className="btn btn-secondary"
                                    data-test="nws-btn-no"
                                    onClick={unsetGdprApiCall}
                                >
                                    {TEXT.OPT_OUT}
                                </button>

                                <p
                                    className="policy-text"
                                    dangerouslySetInnerHTML={{
                                        __html: TEXT.POLICY_TEXT(
                                            LINKS.PRIVACY_POLICY,
                                            LINKS.TERM_AND_CONDITION
                                        ),
                                    }}
                                />
                            </div>
                        </WithStyles>
                    );
                }}
            </ModalContext.Consumer>
        </Modal>
    );
}

export default memo(NewsletterSubscriber);
